import { render, staticRenderFns } from "./CardRegister.vue?vue&type=template&id=8a5f100e"
import script from "./CardRegister.vue?vue&type=script&lang=ts"
export * from "./CardRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports